import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { loadDeploymentConfig } from './services/deploymentConfigService';

// Fire the deployment-mode fetch in the background. We do NOT block first
// render on it — the service defaults to single_tenant on bootstrap, which
// is the safe choice for a client-hosted install and matches the backend
// default. The fetch updates the cached config when it completes; the
// few UI surfaces that branch on isSingleTenant() will simply see the
// default until then, which is the same as the post-fetch result in
// single-tenant mode.
loadDeploymentConfig();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
